import React, { useEffect, useState } from "react";
import { WHITELABEL_CONFIG_URL } from "../../config";
import { fetchThemeSingleInstance } from "../../api/requests";
import { useDispatch, useSelector } from "react-redux";
import { configActions, UIactions } from "../../actions";
import Loading from "../Loading";

const WhiteLabel = ({ children }) => {
  const dispatch = useDispatch();
  const UI = useSelector((state) => state.UI);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const setThemeAndConfig = async () => {
      dispatch(UIactions.startAction("SETTING_THEME", {}));
      try {
        const theme = await fetchThemeSingleInstance(WHITELABEL_CONFIG_URL);
        const { CONFIG, ...whiteLabel } = theme;

        dispatch(configActions.setConfig(CONFIG));
        dispatch(UIactions.setTheme(whiteLabel));
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setIsLoading(false);
        dispatch(UIactions.stopAction("SETTING_THEME", {}));
      }
    };

    setThemeAndConfig();
  }, [dispatch, UI.isInitial]);

  const ErrorDisplay = ({ error }) => (
    <>Oops... Falha ao pegar o whiteLabel: {error}</>
  );
  const LoadingDisplay = () => <Loading />;

  if (isLoading) return <LoadingDisplay />;
  if (error) return <ErrorDisplay error={error} />;

  return <>{children}</>;
};

export default WhiteLabel;
